<script lang="ts">
    import { onMount } from 'svelte'
    import { link, push, replace } from 'svelte-spa-router'
    import type ServiceProvider from '../services/service.provider'
    import type DataProvider from '../services/data.provider'
    import Breadcrumb from '../components/Breadcrumb.svelte'
    import { t } from '../lib/i18n/t';
    import { get } from 'svelte/store';
    import { currentLang } from '../lib/i18n/lang';

    export let serviceProvider: ServiceProvider
    export let dataProvider: DataProvider
    export let params: { id: number } | null

    $: id = params?.id || 0
    $: groups = id === 0 ? serviceProvider.groupService.groups : []
    $: group = id !== 0 ? serviceProvider.groupService.getGroupById(id) : null
    $: activities = serviceProvider.activityService.getActivityByGroup(id)


    onMount(() => {
        // Note: on Brno-EN is only 1 service on zu branch, so ActivitySelector page is not useful
        if (get(currentLang) === 'en' && dataProvider.branchId === 4) {
            replace('/service/86')
        }

        dataProvider.date = null
        dataProvider.time = null
    })
</script>

<Breadcrumb activitySection={true} {dataProvider} {serviceProvider}/>
<div class="bno-container bno-container--spread-min bno-container--centered">
    <div class="bno-container__content">
        {#if group}
            <h2>{group.nazev}</h2>
        {:else}
            <h2>{t('vyberteSluzbu')}</h2>
        {/if}
        <!--{#if id}
            <a href="/" use:link>
                Zpět na úvod
            </a>
        {/if}-->
        {#if groups.length}
            <div class="bno-accordion">
                {#each groups as group}
                    <div class="bno-accordion__header bno-accordion__header--noborder">
                        <h4>
                            <a class="bno-link"
                                href="/{t('page.skupina')}/{group.id}"
                                use:link
                                title={group.nazev}>
                                <span class="bno-icon bno-icon--folder"/>{group.nazev}
                            </a>
                        </h4>
                    </div>
                {/each}
            </div>
        {/if}
        {#if activities.length}
            <ul class="bno-list--plain" class:u-mt--unset={groups.length}>
                {#each activities as activity}
                    <li>
                        <!--
                            Note: on Brno (cs) is also available service 86 on zu branch,
                            but it should redirect to EN web
                        -->
                        {#if $currentLang !== 'en' && dataProvider.branchId === 4 && activity.id === 86}
                            <a
                                href="https://en.brno.cz/w/online-ordering-zu#/service/86"
                                rel="external noopener"
                                class="bno-block-link bno-block-link--arrowed"
                                title={activity.nazev}
                            >
                                <div class="bno-block-link__content">
                                    <h4>
                                        <span class="bno-link">
                                            {activity.nazev}
                                        </span>
                                    </h4>
                                </div>
                            </a>
                        {:else}
                            <a
                                href="/{t('page.sluzba')}/{activity.id}"
                                use:link
                                class="bno-block-link bno-block-link--arrowed"
                                title={activity.nazev}
                            >
                                <div class="bno-block-link__content">
                                    <h4>
                                        <span class="bno-link">
                                            {activity.nazev}
                                        </span>
                                    </h4>
                                </div>
                            </a>
                        {/if}
                    </li>
                {/each}
            </ul>
        {/if}
    </div>
</div>
